import { useTranslation } from 'react-i18next'
import * as dateFnsLocales from 'date-fns/locale'
import * as muiLocales from '@mui/material/locale'
import { Language } from 'src/api/language'

type LocaleList = {
  [key: string]: { dateFns: Locale; mui: muiLocales.Localization; hicLanguage: Language }
}

const locales: LocaleList = {
  en: { dateFns: dateFnsLocales.enUS, mui: muiLocales.enUS, hicLanguage: 'en' },
  it: { dateFns: dateFnsLocales.it, mui: muiLocales.itIT, hicLanguage: 'it' },
  de: { dateFns: dateFnsLocales.de, mui: muiLocales.deDE, hicLanguage: 'de' },
  fr: { dateFns: dateFnsLocales.fr, mui: muiLocales.frFR, hicLanguage: 'fr' },
} as const

export default function useCurrentLocale() {
  const { i18n } = useTranslation()

  let locale = locales['it']
  try {
    const detectedLocale = i18n.language ? locales[i18n.language.split('-')?.[0]] : undefined
    locale = detectedLocale || locales['it']
  } catch (error) {
    console.info('Unable to detect user locale, the default locale will be utilized')
  }

  return { dateFnsLocale: locale.dateFns, muiLocale: locale.mui, hicLanguage: locale.hicLanguage }
}
